import { Box } from '@chakra-ui/react';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import GoalRecurrenceDetailsProvider from '../Context/GoalRecurrenceDetailsProvider';
import Templates from './Templates';
import CheckinReminder from './components/CheckinReminder';
import GoalFrequency from './components/GoalFrequency';
import { useGoalPreferencesContext } from './context/GoalPreferencesProvider';

const GoalPreferencesContainer = (props) => {
  const { goalPreferenceDetails, onGoalFrequencyChange } = useGoalPreferencesContext();

  return (
    <Box
      py={3}
      px={0}
      borderRadius="8px"
      margin={!checkNewNavEnabled() && 4}
      mt={checkNewNavEnabled() && 1}
      padding={0}
    >
      <Templates />
      <GoalFrequency onChange={onGoalFrequencyChange} data={goalPreferenceDetails} />
      <GoalRecurrenceDetailsProvider teamId="-1">
        <CheckinReminder />
      </GoalRecurrenceDetailsProvider>
    </Box>
  );
};

export default GoalPreferencesContainer;
